import _defineProperty from 'babel-runtime/helpers/defineProperty';
/* eslint-disable shopify/jquery-dollar-sign-reference */
/**
 * Custom methods
 * -----------------------------------------------------------------------------
 *
 * @namespace custom
 */

// media queries in Javascript => http://wicky.nillia.ms/enquire.js/
import enquire from 'enquire.js';
// detect if a device is mouseOnly, touchOnly, or hybrid => http://detect-it.rafrex.com/
import detectIt from 'detect-it';
import Flickity from 'flickity';
import axios from 'axios';

var restAPI = '/tools/ha-api/shopify/common';
var shopifyCommonAPI = axios.create({
  // baseURL: '/tools/ha-api/shopify/common'
});
var customMethods = {
  data: function data() {
    return {
      wishlistItems: [],
      items: [],
      isStoredLoginEmail: '',
      isStoredLoginPass: '',
      serchaniseInterval: null
    };
  },


  methods: {
    _initCustomMethods: function _initCustomMethods() {

      app._discountAjaxCart();
      app._GA4Script();

      app.serchaniseInterval = setInterval(app._checkSearchanise(), 700);

      if ($('[data-testimonial-slider ]').length > 0) {
        var _options;

        var $carousel1 = $('[data-testimonial-slider ]');

        var options1 = (_options = {
          adaptiveHeight: true,
          prevNextButtons: false,
          cellAlign: 'left'
        }, _defineProperty(_options, 'adaptiveHeight', true), _defineProperty(_options, 'groupCells', '100%'), _defineProperty(_options, 'accessibility', true), _defineProperty(_options, 'setGallerySize', true), _defineProperty(_options, 'contain', true), _defineProperty(_options, 'lazyLoad', true), _defineProperty(_options, 'pageDots', true), _defineProperty(_options, 'arrowShape', 'M23.9,53.6l45,45c2,2,5.2,2,7.1,0c2-2,2-5.2,0-7.1L34.6,50L76,8.6c2-2,2-5.2,0-7.1c-2-2-5.2-2-7.1,0l-45,45C22,48.4,22,51.6,23.9,53.6L23.9,53.6z M23.9,53.6'), _options);
        if (matchMedia('screen and (min-width: 1024)').matches) {
          options1.adaptiveHeight = false;
        }
        var flkty01 = new Flickity($carousel1[0], options1);
      }

      if ($('[data-testimonial-slider2 ]').length > 0) {
        var _options2;

        var $carousel12 = $('[data-testimonial-slider2 ]');

        var options12 = (_options2 = {
          adaptiveHeight: false,
          prevNextButtons: false,
          cellAlign: 'left'
        }, _defineProperty(_options2, 'adaptiveHeight', true), _defineProperty(_options2, 'groupCells', '100%'), _defineProperty(_options2, 'accessibility', true), _defineProperty(_options2, 'setGallerySize', true), _defineProperty(_options2, 'contain', true), _defineProperty(_options2, 'lazyLoad', true), _defineProperty(_options2, 'pageDots', true), _defineProperty(_options2, 'arrowShape', 'M23.9,53.6l45,45c2,2,5.2,2,7.1,0c2-2,2-5.2,0-7.1L34.6,50L76,8.6c2-2,2-5.2,0-7.1c-2-2-5.2-2-7.1,0l-45,45C22,48.4,22,51.6,23.9,53.6L23.9,53.6z M23.9,53.6'), _options2);
        if (matchMedia('screen and (min-width: 1024)').matches) {
          options12.adaptiveHeight = false;
        }
        var flkty012 = new Flickity($carousel12[0], options12);
      }

      app._disableRightClickonImages();
      var user_login_email = app._getCookie('user_login_email');
      var user_login_pass = app._getCookie('user_login_pass');
      app.isStoredLoginEmail = user_login_email != 'user_login_email' ? app._getCookie('user_login_email') : '';
      app.isStoredLoginPass = user_login_pass != 'user_login_pass' ? app._getCookie('user_login_pass') : '';

      if (app.currentTemplate !== 'index') {
        app._initStoreUtilities(); // methods for the store utilities app
      }
      app._getAllWishlistItem();
      app._navigationCustom();
      app._collectionFilter();
      app._scrollToTop();
      app._instaFeed();

      app._searchLayer();
      app._giftMesasge();
      app._emailToFriendClick();
      app._captch();
      app._getOrderStatus();

      var applePay = setInterval(function () {
        if ($('[data-testid="ApplePay-button"]').length > 0) {
          console.log($('[data-testid="ApplePay-button"]').length);
          $('[data-testid="ApplePay-button"]').closest('li').remove();
          clearInterval(applePay);
        }
      }, 500);

      $('body').on('click', function (e) {
        app._getAllWishlistItem();
        setTimeout(function () {
          if ($('#shopify-section-template-collection').length > 0) {
            $('#AjaxinateContainer .col-6').each(function (i, e) {
              var $col = $(this);
              $.each(app.wishlistItems, function (i, e) {
                if ($('[data-wishlistitems]', $col).attr('data-handle') == app.wishlistItems[i]) {
                  $('[data-wishlistitems]', $col).addClass('wishlist-added-custom');
                } else {
                  $('[data-wishlistitems]', $col).removeClass('wishlist-added-custom');
                }
              });
            });
          }
        }, 1500);
      });

      // remove aria-hidden attribute
      document.querySelectorAll('.remove-aria-hidden').forEach(function (item) {
        item.removeAttribute('aria-hidden');
      });

      app._getCountWishlistItem();
    },
    _GA4Script: function _GA4Script() {
      // console.log('_GA4Script');
      setTimeout(function () {
        var mainElement = document.querySelectorAll('.limespot-recommendation-box-item');
        //console.log('Will execute GA4', mainElement);
        mainElement.forEach(function (element) {
          element.addEventListener('click', function (e) {
            setTimeout(function () {
              var btnSubmits = document.querySelectorAll('.ls-button.ls-quick-view-body__add-to-cart');
              // console.log('clicked', btnSubmits);
              btnSubmits.forEach(function (btnSubmit) {
                // console.log('btnSubmit', btnSubmit);
                btnSubmit.addEventListener('click', function (e) {
                  // console.log('add to cart', btnSubmit, $(btnSubmit));
                  var productHandle = $(btnSubmit).closest('.ls-quick-view-body__info').find('.ls-quick-view-body__product-link').attr('href').split('/products/')[1].split('?')[0];
                  // console.log('productHandle-', productHandle);
                  if (productHandle != '' && productHandle != undefined && productHandle != null) {
                    axios.get('/products/' + productHandle + '.js').then(function (response) {
                      var productJson = response.data;
                      var variantId = productJson.variants[0].id;
                      var currentVariantPrice = productJson.variants[0].price;
                      //  console.log("Product Object: ", productJson);

                      if (productJson.variants.length > 1 && $(btnSubmit).closest('.ls-quick-view-body__info').find('.ls-quick-view-body__options-list').length > 0) {
                        var variantTitle = $(btnSubmit).closest('.ls-quick-view-body__info').find('.ls-quick-view-body__options-list').find('.ls-quick-view-body__option.ls-quick-view-body__option--selected').text().toLowerCase();
                        // console.log('variantTitle', variantTitle);
                        productJson.variants.forEach(function (variant) {
                          if (variant.title == variantTitle) {
                            variantId = variant.id;
                            currentVariantPrice = variant.price;
                          }
                        });
                      }

                      dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                      dataLayer.push({
                        event: "add_to_cart",
                        ecommerce: {
                          currency: window.Shopify.currency.active,
                          value: productJson.price / 100,
                          items: [{
                            item_id: productJson.id,
                            item_name: productJson.title,
                            affiliation: "Google Merchandise Store",
                            index: 0,
                            item_brand: productJson.vendor,
                            item_variant: variantId,
                            location_id: "",
                            price: currentVariantPrice / 100,
                            quantity: 1
                          }]
                        }
                      });
                      console.log('dataLayer', dataLayer);
                    }).catch(function (error) {
                      Rollbar.error('Filename: custom.js, Error occurs while _GA4Script event: ' + error);
                      console.log(error);
                      throw error;
                    });
                  }
                });
              });
            }, 250);
          });
        });
      }, 2000);
    },
    _checkDiscount: function _checkDiscount(discount) {
      //  console.log('_checkDiscount', discount, localStorage.getItem("discountCode"),  app._getCookie('discount_code'));
      var $discount = discount;
      if ($discount == undefined) {
        // $discount = app._getCookie('discountCode');
        $discount = localStorage.getItem("discountCode");
        if ($discount == null || $discount == undefined || $discount == 'discountCode' || $discount == false || $discount == 'false') {
          $discount = app._getCookieValue('discount_code');
          if ($discount == null || $discount == undefined || $discount == 'discountCode' || $discount == false || $discount == 'false') {
            return false;
          }
        }
      }
      // console.log('discount', $discount);
      var cartJson = [];
      app.cart.items.forEach(function (item) {
        var json = {};
        json["variant_id"] = item.variant_id;
        json["quantity"] = item.quantity;

        cartJson.push(json);
      });

      cartJson = JSON.stringify(cartJson);
      // console.log('cartJson', cartJson);
      if ($discount != null) {
        fetch("/payments/config", {}).then(function (response) {
          return response.json();
        }).then(function (response) {
          console.log('response', response.paymentInstruments.accessToken);

          fetch("/wallets/checkouts/?locale=en", {
            "credentials": "include",
            "headers": {
              "Content-Type": "application/json",
              "authorization": "Basic " + btoa(response.paymentInstruments.accessToken),
              "cache-control": "no-cache",
              "pragma": "no-cache",
              "Alt-Used": Shopify.shop
            },
            "referrer": "https://" + Shopify.shop + "/",
            "body": '{"checkout":{"discount_code":"' + $discount + '","line_items":' + cartJson + ',"presentment_currency":"USD"}}',
            "method": "POST"

          }).then(function (response) {
            return response.json();
          }).then(function (response) {
            console.log('response', response);
            $('[data-submit-discount]').removeAttr('disabled');
            if (response.errors) {
              $('[data-discount-message]').text(response.errors.discount_code[0].message).removeClass('d-none');
              $('[data-total-discount]').addClass('d-none');
              $('[data-discount-section]').removeClass('d-none');
              $('[data-discounted-price]').text(app._formatMoney(app.cart.total_price));
              $('.cart-drawer [data-checkout]').attr('href', '/checkout?discount=+++');
              localStorage.setItem("discountCode", false);
              //document.cookie = `discountCode=discountCode`;
              setTimeout(function () {
                $('[data-discount-message]').removeClass('d-none');
              }, 500);
            } else {
              $('[data-total-discount]').removeClass('d-none');
              $('[data-discount-section]').addClass('d-none');
              $('[data-discounted-price]').text(app._formatMoney(response.checkout.payment_due * 100));
              $('[data-discount-code]').html('' + response.checkout.discount_code);
              // if(response.checkout.applied_discount.value_type == 'shipping'){
              //   $('[data-discount-value]').html(`<span class="">You will see free shipping at checkout</span>`);
              // }
              // else {
              $('[data-discount-value]').html('<span style="margin-right: 5px;" class="font-montserrat">-</span>' + app._formatMoney(response.checkout.applied_discount.amount * 100));
              // }
              $('.cart-drawer [data-checkout]').attr('href', '/checkout?discount=' + response.checkout.discount_code);
              $('[data-discount-input]').val('');
              localStorage.setItem("discountCode", '' + response.checkout.discount_code);

              if (response.checkout.applied_discount.amount == 0) {
                $('[data-total-discount]').addClass('d-none');
                $('[data-discount-section]').removeClass('d-none');
                $('[data-discounted-price]').text(app._formatMoney(app.cart.total_price));
                $('.cart-drawer [data-checkout]').attr('href', '/checkout?discount=+++');
                localStorage.setItem("discountCode", false);
              }
              //document.cookie = `discountCode=${response.checkout.discount_code}`;
            }
          }).catch(function (error) {
            // Rollbar.error(`Filename: Custom.js, Error occurs while _checkDiscount event: ${error}`);
            console.log(error);
          });
        }).catch(function (error) {
          // Rollbar.error(`Filename: Custom.js, Error occurs while _checkDiscount event: ${error}`);
          console.log(error);
        });
      }
    },
    _discountAjaxCart: function _discountAjaxCart() {

      console.log('_discountAjaxCart');

      $('body').on('keyup', '[data-discount-input]', function (e) {
        console.log('test', $('[data-discount-input]').val());
        var value = $.trim($('[data-discount-input]').val());
        console.log('value', value.length);
        if (value.length > 0) {
          $('[data-submit-discount]').css('pointer-events', 'inherit');
        } else {
          $('[data-submit-discount]').css('pointer-events', 'none');
        }
      });
      $('body').on('change', '[data-discount-input]', function (e) {
        console.log('test', $('[data-discount-input]').val());
        var value = $.trim($('[data-discount-input]').val());
        console.log('value', value.length);
        if (value.length > 0) {
          $('[data-submit-discount]').css('pointer-events', 'inherit');
        } else {
          $('[data-submit-discount]').css('pointer-events', 'none');
        }
      });
      $('body').on('click', '[data-submit-discount]', function (e) {
        var $discount = $('[data-discount-input]').val();
        $('[data-submit-discount]').attr('disabled', true);
        app._checkDiscount($discount);
      });

      $('body').on('click', '[data-discount-remove]', function (e) {
        $('[data-total-discount]').addClass('d-none');
        $('[data-discount-section]').removeClass('d-none');
        $('[data-discounted-price]').text(app._formatMoney(app.cart.total_price));
        $('.cart-drawer [data-checkout]').attr('href', '/checkout?discount=+++');
        //document.cookie = `discountCode=discountCode`;
        localStorage.setItem("discountCode", false);
      });

      $('body').on('change', '[data-gift-message]', function (e) {
        var value = $.trim($('[data-gift-message]').val());
        var checkoutUrl = $('.cart-drawer [data-checkout]').attr('href');
        // if(value.length > 0) {
        var discount = getUrlParameter(checkoutUrl, 'discount');
        if (discount) {
          $('.cart-drawer [data-checkout]').attr('href', '/checkout?discount=' + discount + '&attributes[Gift-Message]=' + value);
        } else {
          $('.cart-drawer [data-checkout]').attr('href', '/checkout?attributes[Gift-Message]=' + value);
        }
        //}
      });
      $('body').on('keyup', '[data-gift-message]', function (e) {
        var value = $.trim($('[data-gift-message]').val());
        var checkoutUrl = $('.cart-drawer [data-checkout]').attr('href');
        //if(value.length > 0) {
        var discount = getUrlParameter(checkoutUrl, 'discount');
        if (discount) {
          $('.cart-drawer [data-checkout]').attr('href', '/checkout?discount=' + discount + '&attributes[Gift-Message]=' + value);
        } else {
          $('.cart-drawer [data-checkout]').attr('href', '/checkout?attributes[Gift-Message]=' + value);
        }
        // }
      });

      $('body').on('click', '.cart-drawer #giftMessage', function () {

        if (app.currentTemplate !== 'cart') {

          if (!$('.cart-drawer #openMessage').hasClass('show')) {
            $('[data-discount-section]').addClass('discount-hide');
          } else {
            $('[data-discount-section]').removeClass('discount-hide');
          }
        }
      });

      function getUrlParameter(URL, name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(URL);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
      }

      $('body').on('click', 'a[data-target="#giftCardPopup"]', function () {
        app._toggleCartDrawer();
      });
    },
    _disableRightClickonImages: function _disableRightClickonImages() {
      $(document).ready(function () {
        $('img').on('contextmenu', function () {
          return false;
        });
      });
    },
    _checkSearchanise: function _checkSearchanise() {
      if ($(document).find('.snize-input-style').length > 0) {
        $('[data-mobile-search]').removeClass('visible-hidden');
        clearInterval(app.serchaniseInterval);
      }
    },
    _getAllWishlistItem: function _getAllWishlistItem() {
      app.wishlistItems = [];
      if (window._swat != undefined || window._swat != null) {
        window._swat.fetch(function (r) {
          app.items = r;
        });
        setTimeout(function () {
          $.each(app.items, function (i, e) {
            var handle = e.du.split('/');
            app.wishlistItems.push(handle[handle.length - 1]);
          });
        }, 1000);
      }
    },


    /* Created For: Product page: Store product name and url to local storage */
    _emailToFriendClick: function _emailToFriendClick() {
      $('body').on('click', '[data-email-to-friend]', function () {
        localStorage.setItem('email-product-link', $('[data-email-to-friend]').attr('data-url'));
        localStorage.setItem('email-product-name', $('[data-email-to-friend]').attr('data-title'));
      });
    },


    /* Created For: Cart page: Add multiple recipient */
    _giftMesasge: function _giftMesasge() {

      $('body').on('click', '#giftMessage', function () {
        if ($('#openMessage').hasClass('show')) {
          $('#giftMessage span').text('+');
        } else {
          $('#giftMessage span').text('-');
        }
      });

      // $('body').on('focusin', '[data-discount-input]', () => {
      //   let value = $.trim($(this).val());
      //   console.log('value', value.length);
      //   if(value.length > 0) {
      //     $('[data-submit-discount]').css('pointer-events', 'inherit');
      //   }
      //   else {
      //     $('[data-submit-discount]').css('pointer-events', 'none');
      //   }
      // });
    },


    /* Created For: Email a Friend Page : Send product with email */
    _sendEmail: function _sendEmail($event) {
      $event.preventDefault();
      var product_link = localStorage.getItem('email-product-link');
      var product_title = localStorage.getItem('email-product-name');
      var $form = $('#product_sendtofriend_form');
      var recipients = [];
      $('[data-receipients-detail] [data-individual-recipient]').each(function (i, e) {
        var $name = $('[data-name]', this).val();
        var $email = $('[data-email]', this).val();
        recipients.push({ name: $name, email: $email });
      });
      var dataAjax = {
        name: $('[data-input][data-id="sender_name"]').val(),
        email: $('[data-input][data-id="sender_email"]').val(),
        message: $('[data-input][data-id="message"]').val(),
        product_title: product_title,
        product_link: product_link,
        recipients: recipients
      };
      $.ajax({
        type: 'POST',
        url: 'https://script.praella.com/waxing-poetic/api/email-friend',
        data: dataAjax,
        dataType: 'json',
        async: false,
        success: function success(result) {
          window.location.href = product_link;
        }
      });
    },
    _removeRecipient: function _removeRecipient($event) {
      $event.currentTarget.parentElement.parentElement.remove();
    },

    /* Created For: Email a Friend Page : Add multiple recipient */
    _addRecipient: function _addRecipient() {
      if ($('[data-individual-recipient]').length <= 5) {
        var recipientBlock = '';
        recipientBlock += '<div data-individual-recipient class="pb-2 mb-4 border-bottom border-bottom-dotted"><div class="w-100 text-right"><a class="d-block" data-remove-recipient onclick="app._removeRecipient(event)"><span class="close-icon-email"></span></a></div>';
        recipientBlock += '<div class="mb-3">';
        recipientBlock += '<label class="d-block mb-2 font-size-lg text-uppercase">NAME <sup> *</sup></label>';
        recipientBlock += '<input type="text" data-input data-name placeholder="" required class="d-block w-100"/>';
        recipientBlock += '</div>';
        recipientBlock += '<div class="mb-3">';
        recipientBlock += '<label class="d-block mb-2 font-size-lg  text-uppercase">email address<sup> *</sup></label>';
        recipientBlock += '<input type="email" data-input data-email placeholder="" required class="d-block w-100"/>';
        recipientBlock += '</div>';
        recipientBlock += '</div>';
        $('[data-individual-recipient]:last').after(recipientBlock);
        if ($('[data-individual-recipient]').length === 5) {
          $('[data-add-recipient]').hide();
        }
      }
    },


    /* Created For: Header : Set height of search layer */
    _searchLayer: function _searchLayer() {
      var headerHeight = $('#shopify-section-topbar').outerHeight(true) + $('#shopify-section-header').outerHeight(true);
      $('[data-search-layer] .type-3').css('top', headerHeight);
      $(window).scroll(function (e) {
        var headerHeight = $('#shopify-section-topbar').outerHeight(true) + $('#shopify-section-header').outerHeight(true);
        $('[data-search-layer] .type-3').css('top', headerHeight);
      });
    },


    /* Created For: Header : get total count of wishlisted item */
    _getCountWishlistItem: function _getCountWishlistItem() {
      if (wishlistCount) {
        window._swat.wishlistCount(function (r) {
          $('[data-wislistCount]').text(r);
        });
      }
      $('.body').on('hover', function (e) {
        window._swat.wishlistCount(function (r) {
          $('[data-wislistCount]').text(r);
        });
      });
    },


    /* Created For: Collection : Quick View : add to wishlist while quick view */
    _addVariantToswymQuickShop: function _addVariantToswymQuickShop(quickShop, shopurl, event) {
      var allvariants = {};
      $.each(quickShop.product.variants, function (i, e) {
        var title = e.title;
        allvariants[title] = e.title;
      });
      window._swat.addToWishList({
        epi: quickShop.currentVariant.id,
        du: shopurl + '/products/' + quickShop.product.handle,
        empi: quickShop.product.id,
        iu: quickShop.product.featured_image,
        pr: quickShop.currentVariant.price / 100,
        stk: quickShop.currentVariant.inventory_quantity,
        variants: allvariants
      }, function (r) {
        console.log('Added to wishlist');
        setTimeout(function () {
          // app._getCountWishlistItem();
          app._getAllWishlistItem();
          event.target.classList.add('wishlist-added-custom');
        }, 1000);
      });
    },


    /* Created For: Collection : add to wishlist while collection listing */
    _addVariantToswym: function _addVariantToswym(product, shopurl, event) {
      // console.log(product);
      var allvariants = {};
      event.target.style.pointerEvents = 'none';
      $.each(product.variants, function (i, e) {
        var title = e.title;
        allvariants[title] = e.title;
      });
      window._swat.addToWishList({
        epi: product.current_variant.id,
        du: shopurl + '/products/' + product.handle,
        empi: product.id,
        iu: product.featured_image,
        pr: product.current_variant.price / 100,
        stk: product.current_variant.inventory_quantity,
        variants: allvariants
      }, function (r) {
        console.log('Added to wishlist');
        setTimeout(function () {
          // app._getCountWishlistItem();
          app._getAllWishlistItem();
          event.target.classList.add('wishlist-added-custom');
        }, 1000);
      });
    },


    /* Created For: Mobile : Menu top visible for mobile devices */
    _navMobile: function _navMobile() {
      enquire.register('screen and (max-width: 991px)', {
        match: function match() {
          var headerHeight = $('#shopify-section-header').outerHeight(true) + $('#shopify-section-topbar-mobile').outerHeight(true);
          $('.mobile-nav-drawer').css('top', headerHeight - 1);
        },
        unmatch: function unmatch() {
          $('[data-site-overlay]').addClass('overlay');
        }
      });
    },


    /* Created For: Homepage : Scroll To Top button */
    _scrollToTop: function _scrollToTop() {
      $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
          $('.scrollToTop').fadeIn();
        } else {
          $('.scrollToTop').fadeOut();
        }
      });
      // Click event to scroll to top
      $('.scrollToTop').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 1200);
        return false;
      });
    },


    /* Created For: Header(Wrap 2 navigation in one div) - Footer navigation changes  */
    _navigationCustom: function _navigationCustom() {
      // Header: Wrap 2 navigation in one div for - All Jewelry second column
      $('.check-second').wrapAll('<div class="col-4 border-right-  px-md-6-" />');
      enquire.register('screen and (max-width: 767px)', {
        match: function match() {
          $('.footer-menu').addClass('collapse');
        },
        unmatch: function unmatch() {
          $('.footer-menu').removeClass('collapse');
        }
      });
    },


    /* Created For: Collection page: Selected filter remove  */
    _collectionFilter: function _collectionFilter() {
      var _this = this;

      $('body').on('click', '[data-remove]', function (e) {
        var type = $(e.currentTarget).data('remove');
        var $this = $(_this);
        if ($('[data-template-list-filter]').length > 0) {
          $('[data-selected="' + type + '"]').hide();
          $('.dropdown[data-type="' + type + '"]').show();
          $('.dropdown[data-type="' + type + '"] ul li').each(function (i, e) {
            if ($('input', this).is(':checked')) {
              $('input', this).trigger('click');
            }
          });
        } else {
          $('.sorting-bar-inner [data-type="' + type + '"]').show().find('[data-div-dropdowm]').removeClass('show');
          $('.sorting-bar-inner [data-type="' + type + '"] ul li').each(function (i, e) {
            if ($('input', this).is(':checked')) {
              $('input', this).trigger('click');
              if ($.trim($('[data-selectedfilter-tags]').html()) === '') {
                $('[data-filtercontainer]').hide().removeClass('d-block d-md-flex');
              }
            }
          });
        }
        //  app._infiniteScroll();
      });
    },


    /* Created For: Blog page : Normal blog link with archive tag */
    _getBlogurl: function _getBlogurl(event) {
      window.location.href = $(event.currentTarget).val();
    },


    /* Created For: Gift page : Set retail page message limit */
    _checkLimit: function _checkLimit(event, limit) {
      var length = $(event.currentTarget).val().length;
      limit >= length ? $(event.currentTarget).closest('.message').find('[data-messageLimit]').text(limit - length) : $(event.currentTarget).closest('.message').find('[data-messageLimit]').text('0');
    },


    /* Created For: Back page link */
    _goBack: function _goBack() {
      window.history.go(-1);
    },


    // To save customer's info if remember me checked
    _rememberCredentials: function _rememberCredentials(event) {
      var checkedForSave = app.selectors.checkedForSave;
      var email = $(app.selectors.loginEmail).val();
      var password = $(app.selectors.loginPass).val();
      var matchEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);
      var date = new Date();
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
      var expires = '; expires=' + date.toUTCString();

      if ($(checkedForSave).is(':checked') && email != '' && password != '' && matchEmail) {
        document.cookie = '' + ('user_login_email' + '=') + email + expires + '; path=/';
        document.cookie = '' + ('user_login_pass' + '=') + password + expires + '; path=/';
        $(event.target).parents('form#customer_login').submit();
      } else {
        $(event.target).parents('form#customer_login').submit();
      }
    },
    _updateCustomerFeild: function _updateCustomerFeild(type, event) {
      var email = app.selectors.loginEmail;
      var password = app.selectors.loginPass;
      if (type == 'email') {
        app.isStoredLoginEmail = $(email).val();
      } else if (type == 'password') {
        app.isStoredLoginPass = $(password).val();
      }
    },


    /* Created For: instafeed style and script detach */
    _instaFeed: function _instaFeed() {
      if ($('.fs-slider-container').length > 0) {
        // $('.insta-blocks div').attr('data-instafeed', '');
        $('.foursixty .fs-slider-container').detach().appendTo('[data-instafeed]');
        $('.foursixty .fs-slider-container').show();
      }

      if ($('.fs-prepended-detail').length > 0) {
        // console.log('hgh', $('.fs-prepended-detail').length);
        setInterval(function () {
          if ($('[data-instafeed] .fs-wide-timeline').length === 0) {
            $('.foursixty .fs-wide-timeline').detach().appendTo('[data-instafeed]');
            $('.foursixty .fs-normal-timeline').show();
          }
          if ($('[data-instafeed] .fs-narrow-timeline').length === 0) {
            // console.log($('[data-instafeed] .fs-wide-timeline').length);
            $('.foursixty .fs-narrow-timeline').detach().appendTo('[data-instafeed]');
            $('.foursixty .fs-normal-timeline').show();
          }
        }, 1000);
      }
    },
    _getOrderStatus: function _getOrderStatus() {

      // const configForLevel = {
      //   method: 'GET',
      //   url: '/orders/3784144289927.json', 3785181495431
      // };

      // shopifyCommonAPI.post(restAPI, configForLevel)
      //   .then((inventLevelRes) => {


      //   })
      //   .catch((error) => {

      //   });
    },
    _orderStatus: function _orderStatus(event) {
      var $form = $(event.currentTarget).closest('form');
      var isBlank = false;
      $form.find('input[required]').each(function (i, e) {
        if (e.value == '') {
          isBlank = true;
        }
      });
      if (isBlank == true) {
        $form.find('.alert #error_msg').html('Please enter all mandatory fields.');
        $form.find('.alert').fadeIn();
        return false;
      } else {
        $form.find('#error_msg').html('');
        $form.find('.alert').fadeOut();

        var data_ajax = {
          order_number: $('#orderNumber').val()
        };
        $.ajax({
          type: 'POST',
          url: 'https://script.praella.com/waxing-poetic-cin7/api/order-tracking-detail',
          data: data_ajax,
          dataType: 'json',
          async: false,
          success: function success(result) {
            if (result.error == false) {
              window.location.href = result.data;
            } else {
              $form.find('.alert #error_msg').html(result.data);
              $form.find('.alert').fadeIn();
              return false;
            }
            console.log(result);
          }
        });

        // const configForLevel = {
        //   method: 'GET',
        //   url: `/orders/${document.getElementById('orderNumber').value}.json`,
        // };
        // shopifyCommonAPI.post(restAPI, configForLevel)
        //   .then((orderResponse) => {

        //     if (orderResponse.data.order) {
        //       // console.log('status:', orderResponse.data.order.fulfillment_status);
        //       if (orderResponse.data.order.fulfillment_status === 'fulfilled') {
        //         window.location.href = orderResponse.data.order.fulfillments[0].tracking_url;
        //       } else {
        //         $form.find('.alert #error_msg').html('Sorry! We can not check status of Unfulfilled Orders.');
        //         $form.find('.alert').fadeIn();
        //       }
        //       // console.log(orderResponse.data.order.fulfillments[0].tracking_url);
        //     }
        //     if (orderResponse.data.errors) {
        //       if (orderResponse.data.errors.id === 'expected String to be a id') {
        //         // console.log('iiii');
        //         $form.find('.alert #error_msg').html('Please add a correct order ID.');
        //         $form.find('.alert').fadeIn();
        //         return false;
        //       }
        //     }
        //   })
        //   .catch((error) => {
        //     console.log(error);

        //   });
      }
    },
    _captch: function _captch() {
      $('.grecaptcha-badge').remove();
      $('#g-recaptcha-response').closest('noscript').remove();
    }
  }
};

export default customMethods;